// extracted by mini-css-extract-plugin
export default {"wrapper":"a4-z","play":"b4-z"};